import Plyr from 'plyr';

const plyrInstances = new Map();

const handlePlyrBlockClick = (event) => {
	const videoBlock = event.target.closest('.video-block.plyr-managed:not(.video-link):not(.marketing-list-access)');

	if (!videoBlock) {
		return;
	}

	event.preventDefault();

	const plyrEl = videoBlock.querySelector('.plyr-video');
	if (!plyrEl) {
		return;
	}

	// Hide the thumbnail overlay
	const info = videoBlock.querySelector('.video-info');
	const display = videoBlock.querySelector('.video-display');

	if (info) {
		info.classList.add('hidden');
	}

	if (display) {
		display.classList.remove('hidden');
	}

	// If already initialised, just play
	if (plyrInstances.has(plyrEl)) {
		plyrInstances.get(plyrEl).play();
		return;
	}

	// Initialise Plyr and autoplay
	const player = new Plyr(plyrEl, {
		controls: [
			'play-large',
			'play',
			'progress',
			'current-time',
			'mute',
			'volume',
			'fullscreen',
		],
		autoplay: true,
	});

	plyrInstances.set(plyrEl, player);

	player.on('ready', () => {
		player.play();
	});
};

if (document.querySelector('.video-block.plyr-managed')) {
	document.addEventListener('click', handlePlyrBlockClick, false);
}
